import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "75%"
    },
    model: {
      value: _vm.open,
      callback: function ($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_c(VCard, [_c(VCardTitle, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _c(VDivider), _c(VCardText, {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.termsAndConditions
    }
  }), _c(VCardActions, [_c(VSpacer), _c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleAccept
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-check")]), _vm._v("\n          Accept\n        ")], 1), _c(VBtn, {
    class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "color": _vm.color,
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.handleDecline
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-times")]), _vm._v("\n          Decline\n        ")], 1), _c(VSpacer)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };